import * as React from "react";

import {Dimmer, Icon, Loader} from "semantic-ui-react";

import Button from "../../../components/Button";
import {OptionWorkflowStatusMultiUpdateParamActionType} from "../../../services/Client";

import {renderActionTypeLabel} from "./WSMUActionSelection";

interface IWSMUConfirmDialogProps {
    loaderActive: boolean;
    actionType: OptionWorkflowStatusMultiUpdateParamActionType;
    itemsToUpdateCount: number;
    approvedItemsCount: number;
    t: reactI18Next.TranslationFunction;
    backAction: () => void;
    onSubmit: () => void;
}

export const WSMUConfirmDialog = (props: IWSMUConfirmDialogProps) => {

    return (
        <>
            {props.loaderActive &&
                <Dimmer active={props.loaderActive}>
                    <Loader>{props.t("PSL_WF_S_MULTI:TRIGGER_UPDATE_MSG")}</Loader>
                </Dimmer>
            }
            <div style={{marginBottom: '20px'}}>
                <p>
                    <b>{props.t("PSL_WF_S_MULTI:ACTION_TYPE")}</b>
                    {': ' + renderActionTypeLabel(props.actionType, props.t)}
                </p>

                <p>
                    {props.t("PSL_WF_S_MULTI:SUBMIT_TOTAL_TXT") + ' '}
                    <b>{props.itemsToUpdateCount}</b>
                </p>

                {props.actionType === OptionWorkflowStatusMultiUpdateParamActionType.RESET && props.approvedItemsCount > 0 &&
                    <div className={"display--flex"}>
                        <Icon name="exclamation" color="orange" />
                        <p>{props.t("PSL_WF_S_MULTI:RESET_APPROVED_ITEMS_DISCLAIMER", {count: props.approvedItemsCount})}</p>
                    </div>
                }
            </div>

            <div style={{marginTop: '30px'}}>
                <Button
                    icon={'arrow left'}
                    onClick={props.backAction}
                />
                <Button
                    icon={'arrow right'}
                    style={{float: 'right'}}
                    onClick={props.onSubmit}
                />
            </div>
        </>
    );
};



// WEBPACK FOOTER //
// ./src/views/OptionsView/workflowStatusMultiUpdate/WSMUConfirmDialog.tsx